import type { PhoneCountry } from '../phoneCountry/types';
import { isValidPhoneNumberForCountry } from '../phoneCountry/validation';
import type { CustomerSearchRequest, CustomerSearchStatus, CustomerSearchType } from './types';

export * from './types';

export const getCustomerSearchStatus = (customer: { isBlocked?: boolean } | null | undefined): CustomerSearchStatus =>
  customer?.isBlocked ? 'blocked' : customer ? 'existing' : 'new';

/**
 * Is this customer RECORD blocked? True when the Rista record says so (`isBlocked`) or its loyalty
 * block does (`loyaltyInfo.isBlocked`): DP-8122's rule, for the POS's customer step
 * (`useIsCustomerBlocked`, `helpers/commonHelpers`) and the kiosk's verified-customer deal
 * (`ordering/customer`'s `attachSearchedCustomerToSale`).
 */
export const isBlockedCustomer = (
  customer: { isBlocked?: boolean; loyaltyInfo?: { isBlocked?: boolean } | null } | null | undefined,
): boolean => Boolean(customer?.isBlocked || customer?.loyaltyInfo?.isBlocked);

export const getCustomerSearchRequest = ({
  type,
  value,
  pageSize,
  phoneCountry,
}: {
  type: CustomerSearchType;
  value: string;
  pageSize: number;
  phoneCountry?: PhoneCountry | null;
}): CustomerSearchRequest | null => {
  if (type === 'CUSTOMER_ID') {
    const customerId = value.trim();
    return customerId ? { pageSize, customerId } : null;
  }

  if (
    !phoneCountry ||
    !isValidPhoneNumberForCountry(value, phoneCountry)
  ) {
    return null;
  }

  return {
    pageSize,
    phoneNumber: value,
    phoneCountryCode: phoneCountry.code,
    phonePrefix: phoneCountry.prefix,
  };
};

export const nextCustomerSearchRequestId = (() => {
  let requestId = 0;
  return () => ++requestId;
})();
